import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../../common/hooks/useAuth';

/** Only admins get through; the backend checks again on every API call. */
export default function AdminRoute({ children }) {
  const { isAuth, user } = useAuth();
  const location = useLocation();

  if (!isAuth) {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }
  if (user?.role !== 'ROLE_ADMIN') {
    return <Navigate to="/posts" replace />;
  }
  return children;
}
